let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lwvkI")).then(() => parcelRequire('8UOfb'));